const utils 		= require('../../../lib/utils')

// TODO: air-date-and-time-picker usage: select box of times.
//  		problem:
//  			fromTime = null => fromDate = null
// 				fromTime = someTime => fromDate is inherited from now instead of the previous date.
// 			e.g., timeRecordingPropertiesForm of vsb
// 			potential solution: maybe one could save the date for the dayPicker temporarily to be able to set it afterwards if the time gets a valid value again so the date is not lost even though it was null in between states.

module.exports = {
	model: {
		dateFrom: null,
		dateTo: null,
		// gui- and data-timestamp may differ due to inclusive feature (@see this.model.config.inclusiveToDiff).
		dateToGUI: null,
		duration: null,
		config: {
			slim: false, // slim style date only
			slimTime: false, // slim style date and time
			frameLess: false, // just like slim and slimTime but without any margins except for the duration.
			limitBy24Hours: false, // set to date automatically according to a max range of 24 hours.
			preferZeroOver24Hours: true, // by default the 24-hour-mode uses 0 hours if the duration exceeds 24 hours. if one prefers 24 hours over zero hours this flag may be set to false.
			showInfinityButtons: true, // controls if infinity buttons (set null buttons) should be shown or not.
			useDateAndTimePicker: false, // controls if an air-datetime-picker or an air-date-and-time-picker is used.
			// one might include a certain time-frame starting at shown to-date without changing the gui-appearance.
			// e.g., if a period should be displayed as:
			// 			from 1.1.2024 to 2.1.2024
			// 			as 2024-01-01T00:00:00.000+01:00 to 2024-01-03T00:00:00.000+01:00 (useful for db-queries)
			// 			with a duration of 2 days
			// this may be useful when the user expects the to-date to be inclusive a certain to-timeframe even when it is not displayed within the gui.
			inclusiveToDiff: { // format: utils.moment().add(<amount>, <unit>)
				// unit: 'day',
				// amount: 1
			},

			// separatedFieldCodes = {
			// 	from: 'someStartTS',
			// 	to: 'someEndTS',
			// 	duration: 'someDuration',
			// }

			from: { // config for from field. depends on which field-type is used. @see air-datetime-picker or air-date-and-time-picker
				placeholderKey: 'form.fields.periodAir.placeholder.from',
			},
			to: { // config for to field. depends on which field-type is used. @see air-datetime-picker or air-date-and-time-picker
				placeholderKey: 'form.fields.periodAir.placeholder.to',
			},
			duration: { // config for duration text field. @see text.js | dataType = float | format()
				placeholderKey: 'form.fields.periodAir.placeholder.duration',
				showSetZeroButton: false, // show button to set input value to zero
				unit: 'hours',
				inputSize: 6,
				format: {
					decimals: 2,
					// decimalDigit: ',',
					// thousandsDigit: '.',
					// locale: 'de-DE',

					// prefix: '',
					suffix: ' [h]',
					min: 0,
					// max: 0,
				},
			},
		}
	},

	events: {
		button: {
			type: 'click',
			selector: 'button',
			action: function(event){
				event.stopImmediatePropagation()
				const self = event.data.component
				const $target = $(event.target).closest('button')
				const fieldConfig = self.model.config || {}
				const durationFieldConfig = fieldConfig.duration || {}

				if(fieldConfig.showInfinityButtons){
					if(!self.config.disabled && !(fieldConfig.from || {}).disabled && $target.hasClass('from')){
						self.onChange(null)
					} else if(!self.config.disabled && !(fieldConfig.to || {}).disabled && $target.hasClass('to')){
						self.onChange(undefined, null)
					}
				}
				if(durationFieldConfig.showSetZeroButton){
					if(!self.config.disabled && !durationFieldConfig.disabled && $target.hasClass('setZero')){
						self.onChange(undefined, undefined, 0, false, true)
					}
				}
			}
		}
	},

	methods: {
		onBuild(){
			this.initConfig()
		},

		onChange: function(from, to, duration, forceValueChanged = false, updateDuration = false){
			const fieldConfig = this.model.config || {}
			const limitBy24Hours = fieldConfig.limitBy24Hours || false
			const fromPicker = getComponent(this.$.find(fieldConfig.selectors.from))
			const toPicker = getComponent(this.$.find(fieldConfig.selectors.to))
			let checkDiff

			if(from !== undefined){
				from = from || null

				if(from !== this.model.dateFrom && (isNaN((checkDiff = Math.abs(utils.moment(from).diff(this.model.dateFrom, 'milliseconds', true)))) || checkDiff > 0)){
					forceValueChanged = true
					this.model.dateFrom = from

					// in case of limitBy24Hours feature from- and to-values have to be checked and / or corrected to fulfill all necessary conditions.
					if(to === undefined && this.model.dateTo && limitBy24Hours){
						to = this.model.dateTo
					}

					if(from === null){
						if(fieldConfig.showInfinityButtons){
							this.$.find('> .from > button').addClass('active')
						}
						if(fromPicker){
							fromPicker.setDate(null)
						}
					} else {
						if(fieldConfig.showInfinityButtons){
							this.$.find('> .from > button').removeClass('active')
						}
						if(fromPicker.model.dataDATE !== from){
							fromPicker.setDate(from)
						}
					}
				}
			}

			if(to !== undefined){
				to = to || null
				to = this.getToBy24HourMode(to, toPicker)

				const toCorrected = this.getToByDataDiff(to, true) // work out difference between dateTo and dateToGUI

				if(toCorrected !== this.model.dateTo && (isNaN((checkDiff = Math.abs(utils.moment(toCorrected).diff(this.model.dateTo, 'milliseconds', true)))) || checkDiff > 0)){
					forceValueChanged = true
					this.model.dateTo = toCorrected
					this.model.dateToGUI = to

					if(to === null){
						if(fieldConfig.showInfinityButtons) {
							this.$.find('> .to > button').addClass('active')
						}
						if(toPicker){
							toPicker.setDate(null)
						}
					} else {
						if(fieldConfig.showInfinityButtons){
							this.$.find('> .to > button').removeClass('active')
						}
						if(toPicker.model.dataDATE !== to){
							toPicker.setDate(to)
						}
					}
				}
			}

			// change duration if necessary
			if((fieldConfig.separatedFieldCodes || {}).duration){
				if(duration !== undefined){
					duration = Math.abs(duration)

					if(duration !== this.model.duration){
						this.model.duration = duration
						forceValueChanged = true

						if(this.model.dateFrom){
							this.model.dateTo = utils.momentPreciseAdd(this.model.dateFrom, duration, fieldConfig.duration.unit || 'hours').toISOString()
							this.model.dateToGUI = this.getToByDataDiff(this.model.dateTo, false)
							if(fieldConfig.showInfinityButtons) {
								this.$.find('> .to > button').removeClass('active')
							}
							if(toPicker){
								toPicker.setDate(this.model.dateToGUI)
							}
						} else if(this.model.dateTo){
							this.model.dateFrom = utils.momentPreciseAdd(this.model.dateTo, -duration, fieldConfig.duration.unit || 'hours').toISOString()
							if(fieldConfig.showInfinityButtons) {
								this.$.find('> .from > button').removeClass('active')
							}
							if(fromPicker){
								fromPicker.setDate(this.model.dateFrom)
							}
						} else {
							this.model.duration = null
							updateDuration = true
						}
					}
				} else if (this.model.dateFrom && this.model.dateTo){
					const newDuration = Math.abs(utils.moment(this.model.dateTo).diff(this.model.dateFrom, fieldConfig.duration.unit || 'hours', true))
					if(this.model.duration !== newDuration){
						this.model.duration = newDuration
						forceValueChanged = true
						updateDuration = true
					}
				} else if(this.model.duration !== null){
					forceValueChanged = true
					updateDuration = true
					this.model.duration = null
				}

				if(updateDuration){
					const durationPicker = getComponent(this.$.find(fieldConfig.selectors.duration), true)
					if(durationPicker){
						durationPicker.updateValue(this.model.duration)
					}
				}
			}

			let diffLimit = 0, diff
			// NOTE: some config may be used in the future to decline duration-values of e.g., zero => diffLimit = -1
			if(this.model.dateFrom !== null && this.model.dateToGUI !== null && (diff = utils.moment(this.model.dateFrom).diff(this.model.dateToGUI, 'milliseconds', true)) > diffLimit) {
				if(limitBy24Hours){
					this.onChange(this.model.dateFrom, this.getToBy24HourMode(this.model.dateToGUI, toPicker), undefined, forceValueChanged)
				} else if(diff) {
					// if dateTo and dateToGUI are different (e.g., due to getToByDataDiff()) duration has to be recalculated.
					this.onChange(this.model.dateToGUI, this.model.dateFrom, this.model.dateToGUI === this.model.dateTo ? this.model.duration : undefined, true)
				}
			} else if(this.model.duration !== null && limitBy24Hours && (this.model.duration < 0 || this.model.duration > 24)) {
				this.onChange(this.model.dateFrom, this.getToBy24HourMode(this.model.dateToGUI, toPicker), undefined, forceValueChanged)
			} else if(forceValueChanged) {
				const value = {
					from: this.model.dateFrom,
					to: this.model.dateTo,
				}

				if((fieldConfig.separatedFieldCodes || {}).duration){
					value.duration = this.model.duration
				}

				this.parent(parentComponent => {
					parentComponent.trigger('onChildChanged', {
						fieldCode: this.model.fieldCode,
						value,
					})
				})
			}
		},

		onBeforeRender: function(){
			const initDateRange = this.model.dataJSON || {}
			this.model.dateFrom 	= this.model.dateFrom || initDateRange.from || null
			this.model.dateTo 		= this.model.dateTo || initDateRange.to || null
			this.model.dateToGUI 	= this.getToByDataDiff(this.model.dateTo, false)
			this.model.duration 	= this.model.duration || initDateRange.duration || null
		},

		/**
		 * return corrected to-date according to 24hour mode.
		 *
		 * @param to						moment readable
		 * @param toAirDateTimePicker		to-airDatetimePickerComponent
		 * @returns {String|null|*} corrected to- or given to-param in case a correction is not necessary or possible.
		 */
		getToBy24HourMode(to, toAirDateTimePicker){
			const fieldConfig = this.model.config || {}

			if(fieldConfig.limitBy24Hours && this.model.dateFrom && to && toAirDateTimePicker){
				const mFrom = utils.moment(this.model.dateFrom)
				const mTo = utils.moment(to)
				let toIsAtNextDay = false
				if(fieldConfig.preferZeroOver24Hours !== false){
					toIsAtNextDay = mTo.format(utils.moment.HTML5_FMT.TIME_MS) < mFrom.format(utils.moment.HTML5_FMT.TIME_MS)
				} else {
					toIsAtNextDay = mTo.format(utils.moment.HTML5_FMT.TIME_MS) <= mFrom.format(utils.moment.HTML5_FMT.TIME_MS)
				}

				mTo.set({
					year: mFrom.year(),
					month: mFrom.month(),
					date: mFrom.date(),
					hour: mTo.hour(),
					minute: mTo.minute(),
					second: mTo.second(),
					millisecond: mTo.millisecond(),
				})
				if(toIsAtNextDay){
					mTo.add(1, 'day')
				}
				if(utils.isFunction(toAirDateTimePicker.getDataValue)){
					to = toAirDateTimePicker.getDataValue(mTo)
				} else {
					to = mTo.format()
				}
			}

			return to
		},

		/**
		 * correct given date by fieldConfig.inclusiveToDiff settings if necessary.
		 *
		 * @param date					moment || string || Date
		 * @param [guiToData=true]		boolean - should the given date be translated from guiToData or from dataToGUI?
		 * @returns {*|string}			string - corrected iso timestamp or given date param
		 */
		getToByDataDiff(date, guiToData = true){
			const fieldConfig = this.model.config || {}
			const diffConfig = fieldConfig.inclusiveToDiff || {}

			if(date && diffConfig.unit && diffConfig.amount){
				let amount = diffConfig.amount
				if(!guiToData){
					amount = diffConfig.amount * -1
				}

				return utils.moment(date).add(amount, diffConfig.unit).toISOString()
			}

			return date
		},

		initConfig(){
			const fieldConfig = this.model.config || {}
			this.config.disabled = this.config.disabled || fieldConfig.disabled
			if(this.config.disabled){
				if(fieldConfig.from){
					fieldConfig.from.disabled = true
				}
				if(fieldConfig.to){
					fieldConfig.to.disabled = true
				}
				if(fieldConfig.duration){
					fieldConfig.duration.disabled = true
				}
			}

			if(fieldConfig.limitBy24Hours){
				fieldConfig.duration = fieldConfig.duration || {}
				fieldConfig.duration.format = fieldConfig.duration.format || {}
				fieldConfig.duration.format.max = 24
			}

			if(fieldConfig.useDateAndTimePicker){
				if(fieldConfig.limitBy24Hours){
					fieldConfig.to.fields = fieldConfig.to.fields || {}
					fieldConfig.to.fields.date = fieldConfig.to.fields.date || {}
					fieldConfig.to.fields.date.hidden = true
				}

				fieldConfig.selectors = {
					from: '> .from .base_form_fields_air-date-and-time-picker',
					to: '> .to .base_form_fields_air-date-and-time-picker',
					duration: '> .duration .base_form_fields_text',
				}
			} else {
				fieldConfig.selectors = {
					from: '> .from .base_form_fields_air-datetime-picker',
					to: '> .to .base_form_fields_air-datetime-picker',
					duration: '> .duration .base_form_fields_text',
				}
			}
		},

		updateFieldConfig(newFieldConfig){
			utils.refMerge(this.model.config, newFieldConfig || {})
			this.initConfig()
			this.refresh()
		},
	},

	hooks: {
		postAttach($element, options){
			// correct values automatically if necessary
			if(!options.refresh && !this.model.config.disabled){
				this.onChange()
			}

			// const debug = []
			// let sum = 0
			// this.$.find('> *').each(function(){
			// 	const $div = $(this)
			// 	const clazz = $div.attr('class')
			// 	let width
			//
			// 	if(clazz === 'from'){
			// 		$div.find('> div > *').each(function(i){
			// 			width = $(this).outerHeight()
			// 			sum += width
			// 			debug.push(`${clazz}-${i}: ${width}`)
			// 		})
			// 	} else if(clazz === 'duration'){
			// 		$div.find('> *').each(function(i){
			// 			width = $(this).outerHeight()
			// 			sum += width
			// 			debug.push(`${clazz}-${i}: ${width}`)
			// 		})
			// 	} else {
			// 		width = $div.outerHeight()
			// 		sum += width
			// 		debug.push(`${clazz}: ${width}`)
			// 	}
			// })
			// debug.push(`overall: ${sum} vs ${this.$.outerHeight()}`)
			//
			// alert(debug.join('\n'))
		},

		onChildChanged: function($element, options){
			if(options.fieldCode === 'from'){
				this.onChange(options.value)
			} else if (options.fieldCode === 'to'){
				this.onChange(undefined, options.value)
			} else if (options.fieldCode === 'duration'){
				this.onChange(undefined, undefined, options.value)
			}
		},
	}
}
